module.exports = __webpack_public_path__ + "img/content2-1.a2e5a0bf.webp";